import { render } from "./ValidateToken.vue?vue&type=template&id=24c789de&scoped=true&ts=true"
import script from "./ValidateToken.vue?vue&type=script&lang=ts"
export * from "./ValidateToken.vue?vue&type=script&lang=ts"

import "./ValidateToken.vue?vue&type=style&index=0&id=24c789de&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\ehop-admin-vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c789de"]])

export default __exports__